import styled, { CSSProperties } from 'styled-components';

import { fontSize, typography } from '../../assets/themes';
import colors from '../../assets/colors';

export interface IProps {
    style?: CSSProperties;
    type?: keyof typeof typography;
    size?: keyof typeof fontSize;
    color?: keyof typeof colors;
    text?: string;
    numberOfLines?: number;
}

const Text = styled.span<IProps>`
	${p => p.theme.typography[p.type || 'primary']};
	font-size: ${p => p.theme.fontSize[p.size || 'normal']}px;
	color: ${p => p.theme.colors[p.color || 'black']};
`;

const exportedObject = {Text};

export default exportedObject;
